import { cn } from '@monigo/ui';

export interface LogoProps {
  className?: string;
  /** Decorative mark only — when used alone provide an aria-label. */
  ariaLabel?: string;
  /** Use the white version of the icon (for dark/colored backgrounds). */
  white?: boolean;
}

/** Shared MoniGo logo renderer for the customer app brand asset. */
export function Logo({ className, ariaLabel = 'MoniGo', white }: LogoProps) {
  return (
    <img
      src={white ? '/MONIGO_LOGO_WHITE.png' : '/MONIGO_ICON_COLOR.png'}
      alt={ariaLabel}
      className={cn('h-10 w-auto object-contain', className)}
    />
  );
}
